import { defineCapability } from './internal';
import { args } from '../common/args';
export const DELETE_GLOBAL_STYLES_CAP = defineCapability({
  name: 'DELETE_GLOBAL_STYLES_CAP',
  args: {
    by: args.or(args.literal('selector'), args.literal('persistenceId')),
    value: args.string(),
    mode: args.or(args.literal('session'), args.literal('indefinite'))
  }
});